import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import styles from './index.module.scss';

var ChoiceInfo = function ChoiceInfo(props) {
  return /*#__PURE__*/React.createElement("p", _extends({}, props, {
    className: styles.info
  }));
};

export default ChoiceInfo;